import { types } from '../../types';

const setGetListExchangeRatesAction = (payload) => {
  return {
    type: types.exchangeRates.SET_LIST_EXCHANGE_RATES,
    payload,
  }
}

const setGetViewExchangeRatesAction = (payload) => {
  return {
    type: types.exchangeRates.SET_VIEW_EXCHANGE_RATES,
    payload
  }
}

export {
  setGetListExchangeRatesAction as SetGetListExchangeRatesAction,
  setGetViewExchangeRatesAction as SetGetViewExchangeRatesAction
}
